import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  productName: {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.select.light,
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  productLink: {
    textDecoration: 'none',
    color: theme.palette.select.light,
  },
  loaderRootContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(11),
  },
  LogoImg: {
    pointerEvents: 'none',
    height: '48px',
    width: '48px',
  },
  loaderHeader: {
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '28px',
    color: theme.palette.labraText.tertiary,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'center',
    marginTop: theme.spacing(3),
  },
  loaderSubHeader: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'center',
    marginTop: theme.spacing(1),
  },
  loadingSpinner: {
    color: theme.palette.labraFormProgress.main,
    width: '31px',
    height: '31px',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(11),
  },
  errorMessage: {
    color: theme.palette.error.dark,
    fontSize: '12px',
    marginTop: theme.spacing(1),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
  },
}))
